module.exports = ".confirm-header {\n  color: green; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/forgot-password/confirm-password-set-dialog/confirm-password-set-dialog.component.scss
// module id = 170
// module chunks = 1